export enum FavoriteEntityType {
  PROFESSION,
  PROVIDER_SCHOOL,
  PROVIDER_COMPANY,
  PROVIDER_INSTITUTION,
  JOB
}
